<template>
  <div class="content">
    <img :src="paySuccess"/>
    <h2>点击下方按钮，下载对应数据</h2>
    <a-dropdown>
      <a-menu slot="overlay" @click="printExcel($event,'signUp')">
        <a-menu-item key="1">
          {{$t('官方打印版')}}
        </a-menu-item>
      </a-menu>
      <a-button icon="download"> {{$t('下载报名列表')}} <a-icon type="down" /> </a-button>
    </a-dropdown>
    <a-button style="" icon="download" type="primary" @click="downloadAgency">{{$t('下载签到表')}}</a-button>
    <template v-if="matchInfo.insuranceStatus !== '2'">
      <a-divider type="vertical" />
      <a-button style="" icon="download" type="primary" @click="printExcel(null,'insurance')">{{$t('下载保险凭证')}}</a-button>
      <a-divider type="vertical" />
      <a-button style="" icon="edit" type="primary" @click="$refs.invoiceInformation.show(matchId, agencyId)">填写开票信息</a-button>
    </template>
    <InvoiceInformation ref="invoiceInformation"/>
  </div>
</template>
<script>
import store from '@/store'
import InvoiceInformation from '@comm/components/join/pay/InvoiceInformation'
export default {
  components: {
    InvoiceInformation
  },
  data () {
    return {
      paySuccess: require('@comm/assets/join/pay_success.png'),
      matchInfo: store.getters['match/matchInfo'],
      accountId: store.getters['user/accountId'],
      matchId: this.$route.query.matchId
    }
  },
  props: {
    agencyId: {
      type: Number
    },
    agencyName: {
      type: String
    }
  },
  methods: {
    printExcel (type, downloadType) {
      if (downloadType === 'signUp') {
        this.$api.join.exportSignDataPdfV2({matchId: this.$route.query.matchId, agencyId: this.agencyId, type: type.key}).then(res => {
          this.readerDownload(res, downloadType)
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$api.join.exportInsurancePdf({matchId: this.$route.query.matchId, agencyId: this.agencyId}).then(res => {
          this.readerDownload(res, downloadType)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    downloadAgency () {
      this.$api.match.downloadJoinAgencyPlayer({matchId: this.$route.query.matchId, agencyId: this.agencyId}).then(res => {
          let type = res.type
          // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
          if (type.includes('application/json')) {
            let reader = new FileReader()
            var _this = this
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).msg // 错误信息
              _this.$message.error(message)
            }
            reader.readAsText(res)
          } else {
            let blob = new Blob([res])
            console.log(blob)
            let url = window.URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = url
            link.download = this.agencyName + '签到表.xls' // 下载后文件名
            document.body.appendChild(link)
            link.click() // 点击下载
          }
        }).catch(err => {
          console.log(err)
        })
    },
    readerDownload (res, downloadType) {
      let type = res.type
      // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
      if (type.includes('application/json')) {
        let reader = new FileReader()
        var _this = this
        reader.onload = function (event) {
          let content = reader.result
          let message = JSON.parse(content).msg // 错误信息
          _this.$message.error(message)
        }
        reader.readAsText(res)
      } else {
        let blob = new Blob([res])
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = url

        link.download = downloadType == 'signUp' ? '报名数据.pdf' : '保险凭证.pdf' // 下载后文件名
        document.body.appendChild(link)
        link.click() // 点击下载
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .content {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 50px;
    h2 {
      margin-top: 20px;
      color: #1890ff;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/PayDownload.vue